const swipeUp = new CustomEvent('swipe', { detail: 'up' })
const swipeDown = new CustomEvent('swipe', { detail: 'down' })

export function SwipeChecker(op) {
    const options = Object.assign({
        wheelDelta: 1,
        touchDelta: 30
    }, op)
    let delta
    this.start = null

    const getTouchPos = e => e.touches[0].clientY

    this.check = e => {
        if (window.TouchEvent && e instanceof window.TouchEvent) {
            switch (e.type) {
                case 'touchstart':
                    this.start = getTouchPos(e)
                    return false
                case 'touchmove':
                    if (this.start === null) {
                        this.start = getTouchPos(e)
                        return false
                    }
                    delta = getTouchPos(e) - this.start
                    return delta > options.touchDelta ? 'up'
                         : delta < -options.touchDelta ? 'down'
                         : false
                case 'touchend':
                    this.start = null
                    break
            }
        }
        else if (e instanceof WheelEvent) {
            return e.deltaY > options.wheelDelta ? 'down'
                 : e.deltaY < -options.wheelDelta ? 'up'
                 : false
        }
        else throw new TypeError('Event must be TouchEvent or WheelEvent')
    }
}

const attachHandlers = (el, binding, vnode) => {
    const context = vnode.context
    const options = Object.assign({
        wheelDelta: 50,
        touchDelta: 30
    }, binding.value)
    const checker = new SwipeChecker(options)

    const checkAndDispatch = e => {
        if (options.deactive && context[options.deactive]) {
            return
        }
        const res = checker.check(e)
        if (! res) {
            return
        }
        el.dispatchEvent(res === 'up' ? swipeUp : swipeDown)
    }

    el.addEventListener('touchstart', checkAndDispatch)
    el.addEventListener('touchmove', checkAndDispatch)
    el.addEventListener('touchend', checkAndDispatch)
    el.addEventListener('wheel', checkAndDispatch)
    return () => {
        el.removeEventListener('touchstart', checkAndDispatch)
        el.removeEventListener('touchmove', checkAndDispatch)
        el.removeEventListener('touchend', checkAndDispatch)
        el.removeEventListener('wheel', checkAndDispatch)
    }
}

export const swipe = {
    inserted: (el, binding, vnode) => {
        el.$$cleanSwipe = attachHandlers(el, binding, vnode)
    },
    unbind: (el) => {
        el.$$cleanSwipe()
    }
}